var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticStyle: { height: "100vh" }, attrs: { direction: "vertical" } },
    [
      _c("publicHeader"),
      _c("el-main", [
        _c("div", { staticClass: "error404" }, [
          _c("h1", [_vm._v("404")]),
          _c("h2", [_vm._v("Page Not Found")]),
          _c("p", [
            _vm._v("The destination page currently does not exist."),
            _c("br"),
            _vm._v("Please return to the login screen."),
          ]),
          _c(
            "p",
            { staticClass: "go" },
            [
              _c("router-link", { attrs: { to: { name: "sign_in" } } }, [
                _c("i", { staticClass: "el-icon-back" }, [
                  _vm._v(_vm._s(_vm.$t("sign_in.back_signin"))),
                ]),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _c("publicFooter"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }